// extracted by mini-css-extract-plugin
export default {"questionWrapper":"AbilityQuestion-module__questionWrapper__fKYnU","question":"AbilityQuestion-module__question__Yc7sN","options":"AbilityQuestion-module__options__VeTqj"};